import { Inject, Injectable, Optional } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { MailtoLink, OpenWindowProvider, isMailtoLink } from '@platform-frontend/util';
import { TranslationService } from '../translation.service';
import { ExternalLinkRenderer } from './external-link-renderer';
import { LinkRendererService } from './link-renderer.service';

@Injectable()
export class MailtoLinkRenderer {
  constructor(
    private linkRendererService: LinkRendererService,
    @Optional() @Inject(OpenWindowProvider) private openWindowProvider: string | null,
    private translationService: TranslationService,
    private translocoService: TranslocoService
  ) {}

  supports(link: unknown): link is MailtoLink {
    return isMailtoLink(link);
  }

  render(link: MailtoLink, targetElement: HTMLAnchorElement): void {
    console.log('link', link);
    const url =
      'mailto:' +
      link.mailto +
      '?subject=' +
      this.translationService.translate(link.subject) +
      (link.body ? '&body=' + this.translationService.translate(link.body) + '%0A%0A' : '');
    new ExternalLinkRenderer(this.linkRendererService, this.openWindowProvider, this.translocoService).render(
      { ...link, url, target: '_blank' },
      targetElement
    );
  }
}
